import React from "react";
import { NavMenu } from "tea-component";

export default function Logo(props: any) {
  const { children } = props
  return <NavMenu.Item>
    {children}
  </NavMenu.Item>
}